import { APIAutenticacao } from '../services/autenticacao';

const CryptoJS = require('crypto-js');

export const encryptionPassword = async (matricula, senha, token = '') => {
  const encryptionKey = await APIAutenticacao.geraChave(matricula, token);
  const key = CryptoJS.enc.Utf8.parse(encryptionKey);
  const iv = CryptoJS.enc.Utf8.parse(encryptionKey);
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(senha), key, {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
};
